import React from "react";

function UnderConstruction(){
    return(
        <div className="underconstruction">
            <img src="assets/gear.gif" alt="gear"/>
            Under Construction!
            <img src="assets/gear.gif" alt="gear"/>
        </div>
    );
}

export default UnderConstruction;